import styled, { css } from 'styled-components';
import fontService, { FontWeight, TextType } from 'services/FontService';
import { Button, ButtonRound } from 'components/atoms';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StageText = styled.p`
  color: var(--off-white-fff-7-eb, #fff7eb);
  text-align: center;
  font-family: 'HalvarBreit';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 88.889% */
  text-transform: uppercase;

  svg {
    margin: 0 4px 0 10px;
  }
`;

export const StageCountdown = styled.div`
  border-radius: 8px;
  background: #7107aa;
  display: inline-flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  min-width: 164px;
  text-align: center;
  margin-left: 12px;
`;

export const TableDescription = styled.div`
  display: flex;
`;

export const Item = styled.div<{ hasNextJPDate?: boolean }>`
  display: flex;
  align-items: center;

  &:not(:first-of-type) {
    &:before {
      content: '';
      display: block;
      height: 8px;
      width: 1px;
      margin: ${({ hasNextJPDate }) => (hasNextJPDate ? '40px 26px' : '32px')};

      ${({ theme: { text } }) => `
        background-color: ${text.primaryDisabled};
      `}
    }
  }
`;

export const ItemInner = styled.div``;

export const ItemLabel = styled.p`
  ${fontService.text({ type: TextType.captionSmall })};
  ${({ theme: { text } }) => `
    color: ${text.secondaryDisabled};
  `}
`;

export const ItemValue = styled.p`
  margin-top: 4px;
  ${fontService.text({ type: TextType.normal, lineHeight: 112, weight: FontWeight.bold })};
  ${({ theme: { text } }) => `
    color: ${text.secondaryDefault};
  `}
`;

export const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Buttons = styled.div`
  display: flex;
  margin-left: 24px;
`;

const RoundButtonStyled = styled(ButtonRound)`
  ${({ theme: { button } }) => `
    &:disabled {
      background-color: ${button.cancel};
      border-color: ${button.cancelBorder};

      & > * {
        opacity: 0.24;
      }
    }
 `};
`;

export const UserButton = styled(RoundButtonStyled)`
  margin-left: 24px;
  ${({ theme: { button } }) => `
    border-color: ${button.primaryBorder};
    background-color: ${button.primary};

    &:hover:not([disabled]) {
      background-color: ${button.primaryHover};
    }
  `}
`;

export const PowerButton = styled(RoundButtonStyled)`
  ${({ theme: { button } }) => `
    border-color: ${button.errorBorder};
    background-color: ${button.error};

    &:hover:not([disabled]) {
      background-color: ${button.errorHover};
    }
  `}
`;

export const ItemBox = styled.div`
  display: flex;
  align-items: center;
`;

export const ItemText = styled.p`
  ${fontService.text({ type: TextType.extraSmall })};
  ${({ theme: { text } }) => `
    color: ${text.secondaryDisabled};
    line-height: 16px;
  `}
`;

export const JPDate = styled.div`
  flex-shrink: 0;
  margin-left: 24px;
  ${fontService.text({ size: 16, weight: FontWeight.medium })};
  ${({ theme: { text } }) => css`
    color: ${text.primaryDefault};
  `}
`;

export const ShuffleButton = styled(Button)`
  box-sizing: border-box;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  min-height: unset;
  max-height: 40px;
  max-width: 128px;
  border: 1px solid #f38144;
  background-color: #cc6833;
  ${fontService.text({ size: 12, weight: FontWeight.medium })};
  margin-right: 65px;

  &:before {
    position: absolute;
    content: '';
    display: block;
    height: 8px;
    width: 1px;
    right: -33px;

    ${({ theme: { text } }) => `
        background-color: ${text.primaryDisabled};
      `}
  }

  &:hover {
    background-color: #ec7c46;
  }

  svg {
    flex-shrink: 0;
  }

  ${({ theme: { button, text } }) => `
    &:disabled {
      background-color: ${button.cancel};
      border-color: ${button.cancelBorder};
      
      & > svg {
        path {
          fill: ${text.primaryDisabled};
        }
      }
    }`}
`;
